export default "__VITE_ASSET__BMHwO0C$__"